import { memo } from "react";
import { useTypedSelector } from "hooks";
import { route, when } from "util/support";
import { isFormChanged } from "util/forms";
import { selectConstants, selectIsConstantsLoading } from "features/general/selectors";
import { useIbanXSActions } from "features/openBanking/actions";
import type { IbanXsBank } from "features/openBanking/types";
import ActionPanel from "ui/molecules/ActionPanel";
import { TabLayout } from "ui/widgets/StatefulTabs";
import { useResourceContext } from "ui/widgets/Resource";
import { IbanXS } from "ui/forms/OpenBanking";

const EditIbanXSDetailResourceForm = () => {
    const isConstantsLoading = useTypedSelector(selectIsConstantsLoading);
    const constants = useTypedSelector(selectConstants);

    const { updateIbanXsBank } = useIbanXSActions();

    const { resource, onClose } = useResourceContext<IbanXsBank>();

    const formProps: IbanXS.IbanXSForm = {
        bootstrapData: {
            OpenBankingLogosDomain: constants.OpenBankingLogosDomain,
        },
        initialValues: IbanXS.getInitialValues(resource),
        isBootstrapDataLoading: (
            isConstantsLoading
        ),
        onSaveOrCreate: async ({ logoUrl, ...values }) => {
            const logo = logoUrl?.trim();
            const [request, result] = updateIbanXsBank({
                ...values,
                logoUrl: when(
                    logo,
                    route([logo]),
                    null
                ),
                pki: resource.pki
            });

            await request;
            onClose();

            return result;
        }
    };

    const form = IbanXS.useForm(formProps);

    return (
        <TabLayout>
            <IbanXS.Form
                {...form}
                {...formProps}
            >
                <ActionPanel
                    isLoading={form.isSubmitting}
                    onSave={async () => { }}
                    onCancel={onClose}
                    SaveActionProps={{
                        type: 'submit',
                        disabled: !form.isValid || !isFormChanged(form),
                        loading: form.isSubmitting
                    }}
                />
            </IbanXS.Form>
        </TabLayout>
    );
};

export default memo(EditIbanXSDetailResourceForm);
